import { HbApiClient } from "@storyplay/common";
import { RESTAPIClient } from "../../containers/studio/di/client/RESTAPIClient";
import { AppOptions } from "../../utils/AppOptions";

const hbApiClient = new HbApiClient(new RESTAPIClient(
  async () => localStorage.getItem(AppOptions.LOCAL_STORAGE_KEY_TOKEN),
  AppOptions.SERVER_ADDRESS
))

export { hbApiClient }